import React from 'react';
import {Route} from 'react-router-dom'
import {Body, Footer, Header, HeaderTopGradient, ProgressBar, Toast} from "./components";

import Sample from '../sample';
import Record from "../record";
import Periods from "../periods/PeriodContainer";
import Irr from '../irr';
import IrrSample from '../irr-sample';
const Layout = () => (
  <React.Fragment>
    <Toast />
    <HeaderTopGradient/>
    <Header/>
    <ProgressBar />
    <Body>
      <Route exact path="/" component={Periods}/>
      <Route path="/review" component={Periods}/>
      <Route path="/period/:id" component={Sample}/>
      <Route path="/records/:periodId/:recordId" component={Record}/>
      <Route exact path="/irr" component={Irr}/>
      <Route path="/irr/:sampleId" component={IrrSample}/>
    </Body>
    <Footer/>
  </React.Fragment>
);

export default Layout;



// WEBPACK FOOTER //
// ./src/modules/layout/index.js